var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgCloseIcon = function SvgCloseIcon(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.8333 5.34175L14.6583 4.16675L9.99996 8.82508L5.34163 4.16675L4.16663 5.34175L8.82496 10.0001L4.16663 14.6584L5.34163 15.8334L9.99996 11.1751L14.6583 15.8334L15.8333 14.6584L11.175 10.0001L15.8333 5.34175Z",
    fill: "white"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCloseIcon);
export { ForwardRef as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjAiIGhlaWdodD0iMjAiIHZpZXdCb3g9IjAgMCAyMCAyMCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE1LjgzMzMgNS4zNDE3NUwxNC42NTgzIDQuMTY2NzVMOS45OTk5NiA4LjgyNTA4TDUuMzQxNjMgNC4xNjY3NUw0LjE2NjYzIDUuMzQxNzVMOC44MjQ5NiAxMC4wMDAxTDQuMTY2NjMgMTQuNjU4NEw1LjM0MTYzIDE1LjgzMzRMOS45OTk5NiAxMS4xNzUxTDE0LjY1ODMgMTUuODMzNEwxNS44MzMzIDE0LjY1ODRMMTEuMTc1IDEwLjAwMDFMMTUuODMzMyA1LjM0MTc1WiIgZmlsbD0id2hpdGUiLz4KPC9zdmc+Cg==";